import { Outlet, useNavigate } from 'react-router-dom';
import { LayoutModal } from 'components';

export const Send = () => {
  const navigate = useNavigate();
  return (
    <LayoutModal onClose={() => navigate('/wallet')}>
      <Outlet />
    </LayoutModal>
  );
};
